import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "\n      max-w-container\n      flex\n      items-center\n      py-4\n      px-container\n      border-b border-amff-gray border-opacity-25\n    " }
const _hoisted_2 = { class: "mr-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "px-2 text-amff-gray" }, "·", -1)
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  id: "aria-langDropdown",
  class: "absolute top-5 right-0 bg-amff-teal z-30"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialLinks = _resolveComponent("SocialLinks")
  const _component_AnchorLink = _resolveComponent("AnchorLink")
  const _component_ChevronIcon = _resolveComponent("ChevronIcon")
  const _component_CheckIcon = _resolveComponent("CheckIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t("header.mallorca_edition")) + " ", 1),
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("header.online_edition")), 1)
    ]),
    _createVNode(_component_SocialLinks, { class: "text-base" }),
    _createVNode(_component_AnchorLink, {
      to: { name: 'history' },
      class: ["px-2 hover:text-amff-teal", { 'text-amff-teal': _ctx.isCurrentLinkActive('history') }]
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("header.history")) + ". ", 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode("div", _hoisted_4, [
      _createVNode("button", {
        type: "button",
        class: "px-2 flex items-center gap-2",
        "aria-expanded": _ctx.langDropdownOpen,
        "aria-controls": "aria-langDropdown",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.langDropdownOpen = true))
      }, [
        _createTextVNode(_toDisplayString(_ctx.currentLang === "es"
            ? _ctx.$t("short_languages.es")
            : _ctx.$t("short_languages.cat")) + " ", 1),
        _createVNode(_component_ChevronIcon, {
          fill: "currentColor",
          class: "inline-block w-3 h-3 text-amff-teal",
          style: 
            _ctx.langDropdownOpen
              ? `transform: rotate(180deg)`
              : `transform: rotate(0deg)`
          
        }, null, 8, ["style"])
      ], 8, ["aria-expanded"]),
      _withDirectives(_createVNode("div", _hoisted_5, [
        _createVNode("button", {
          type: "button",
          class: "\n            py-4\n            px-6\n            text-amff-black\n            w-40\n            flex\n            justify-between\n            hover:bg-amff-black\n            hover:text-amff-teal\n          ",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchLang('es')))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("languages.es")) + " ", 1),
          (_ctx.currentLang === 'es')
            ? (_openBlock(), _createBlock(_component_CheckIcon, {
                key: 0,
                class: "w-4 h-4"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("button", {
          type: "button",
          class: "\n            py-4\n            px-6\n            text-amff-black\n            w-40\n            flex\n            justify-between\n            hover:bg-amff-black\n            hover:text-amff-teal\n          ",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchLang('cat')))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("languages.cat")) + " ", 1),
          (_ctx.currentLang === 'cat')
            ? (_openBlock(), _createBlock(_component_CheckIcon, {
                key: 0,
                class: "w-4 h-4"
              }))
            : _createCommentVNode("", true)
        ])
      ], 512), [
        [_vShow, _ctx.langDropdownOpen]
      ])
    ])
  ]))
}